<script setup>
import { ref } from 'vue';
import CookieBanner from '@/components/CookieBanner.vue';

</script>
<script>
export default {
  data: () => ({
  }),
}
</script>

<template>
    <v-app>
        <header class="bg-white p-4 flex justify-between items-center container mx-auto">
            <a :href="route('web.home')">
                <img src="/images/common/logo.png" alt="Logo" class="mb-2" />
            </a>
        </header>
        <div class="border-b border-gray-200"></div>

        <v-main>
            <slot />
        </v-main>

        <footer class="bg-gray-900 text-white py-12">
            <div class="container mx-auto px-4">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
                    <!-- Company Info -->
                    <div class="lg:col-span-2">
                        <img src="/images/common/logo-dark.png" alt="Logo" class="mb-4" />
                        <h3 class="text-xl font-bold mb-2">Lexo</h3>
                        <p class="text-gray-300 mb-4">Povezujemo vas z pravnimi storitvami.</p>
                        <p class="text-gray-400 text-sm">
                            Naša platforma omogoča enostavno iskanje in povezovanje s kvalificiranimi pravnimi strokovnjaki po vsej Sloveniji.
                        </p>
                    </div>

                    <!-- Quick Links -->
                    <div>
                        <h4 class="text-lg font-semibold mb-4">Hitre povezave</h4>
                        <ul class="space-y-2 list-none pl-0">
                            <li><a :href="route('web.home')" class="text-gray-300 hover:text-white transition-colors">Domov</a></li>
                            <li><a :href="route('web.blogs.list')" class="text-gray-300 hover:text-white transition-colors">Blog</a></li>
                            <li><a :href="route('web.contact')" class="text-gray-300 hover:text-white transition-colors">Kontakt</a></li>
                            <li><a :href="route('web.join-us')" class="text-gray-300 hover:text-white transition-colors">Pridruži se</a></li>
                        </ul>
                    </div>

                    <!-- Legal -->
                    <div>
                        <h4 class="text-lg font-semibold mb-4">Pravne informacije</h4>
                        <ul class="space-y-2 list-none pl-0">
                            <li><a :href="route('web.privacy-policy')" class="text-gray-300 hover:text-white transition-colors">Politika zasebnosti</a></li>
                            <li><a :href="route('web.terms-conditions')" class="text-gray-300 hover:text-white transition-colors">Pogoji uporabe</a></li>
                            <li><a :href="route('web.cookie-policy')" class="text-gray-300 hover:text-white transition-colors">Politika piškotkov</a></li>
                            <li><a :href="route('web.legal-notice')" class="text-gray-300 hover:text-white transition-colors">Pravno obvestilo</a></li>
                            <li><a :href="route('web.impressum')" class="text-gray-300 hover:text-white transition-colors">Impresum</a></li>
                        </ul>
                    </div>
                </div>

                <!-- Bottom Section -->
                <div class="border-t border-gray-700 pt-8">
                    <div class="flex flex-col md:flex-row justify-between items-center">
                        <div class="text-gray-400 text-sm mb-4 md:mb-0">
                            &copy; {{ new Date().getFullYear() }} Lexo. Vse pravice pridržane.
                        </div>
                        <div class="flex space-x-6">
                            <!-- Facebook -->
                            <a href="#" class="text-gray-400 hover:text-white transition-colors">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                </svg>
                            </a>
                            <!-- X (Twitter) -->
                            <a href="#" class="text-gray-400 hover:text-white transition-colors">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                                </svg>
                            </a>
                            <!-- LinkedIn -->
                            <a href="#" class="text-gray-400 hover:text-white transition-colors">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

        <!-- Cookie Banner -->
        <CookieBanner />
    </v-app>
</template>
